module.exports = __webpack_public_path__ + "media/IIF_MoMA_Edit_03_v3.f848245d.ogg";